module.exports = __webpack_public_path__ + "img/mail_sent.9fd45d77.svg";